import { httpCreate } from './http';

const http = httpCreate('/srv/official-msg-config');

export const officialMsgConfig = {
	// 获取直播间消息推送设置
	getOfficialMsgConfig(activityId) {
		return http.get(`/${activityId}`);
	},
	// 保存模板通知
	saveOfficialMsgConfig(activityId, params) {
		return http.post(`/${activityId}`, params);
	},
	// 保存订阅通知
	saveSubscribeConfig(activityId, params) {
		return http.post(`/subscribe/${activityId}`, params);
	},
};
